const features = [
  {
    id: 1,
    title: '完全免费',
    desc: '所有电视剧资源免费在线观看，不设会员制度，不强制充值，真正零门槛追剧。',
    icon: 'ri-money-cny-circle-line',
    color: 'text-primary-600',
    bg: 'bg-primary-100',
  },
  {
    id: 2,
    title: '高清流畅',
    desc: '支持1080P全高清画质播放，先进视频传输技术确保不缓冲、不卡顿的流畅体验。',
    icon: 'ri-4k-line',
    color: 'text-accent-600',
    bg: 'bg-accent-100',
  },
  {
    id: 3,
    title: '海量片源',
    desc: '收录3000+部热门电视剧，国产剧、韩剧、美剧、日剧、泰剧全覆盖，每日更新。',
    icon: 'ri-database-2-line',
    color: 'text-secondary-600',
    bg: 'bg-secondary-100',
  },
  {
    id: 4,
    title: '全端适配',
    desc: '网页端与移动端完美适配，躺在床上用手机就能追剧，支持画质切换与倍速播放。',
    icon: 'ri-device-line',
    color: 'text-primary-600',
    bg: 'bg-primary-100',
  },
  {
    id: 5,
    title: '更新迅速',
    desc: '剧集更新速度行业领先，热播剧同步上线，全集资源第一时间收录，追剧快人一步。',
    icon: 'ri-flashlight-line',
    color: 'text-accent-600',
    bg: 'bg-accent-100',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            平台特色
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">平台特色 · 为什么选择被窝网电影</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">五大核心优势，打造极致追剧体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feat) => (
            <div key={feat.id} className="group text-center p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className={`w-14 h-14 rounded-2xl ${feat.bg} ${feat.color} flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}